import { clientFor } from '@yc/api-client'

const api = clientFor('/mtm/api')

/** 工作台 KPI：与后端 internal/home/service.go 的 Stats 的 JSON 字段一一对应 */
export interface HomeStats {
  /** 联运计划总数 */
  total_plans: number
  /** 草稿计划数（还在编排区段） */
  draft: number
  /** 已确认、等着开工的计划数 */
  confirmed: number
  /** 在途（至少一段已完成）的计划数 */
  in_transit: number
  /** 已完结的计划数 */
  completed: number
  /** 已取消的计划数 */
  cancelled: number
  /** 承运商档案数 */
  carriers: number
  /** 场站档案数 */
  hubs: number
}

export const getHomeStats = (): Promise<HomeStats> => api.get<HomeStats>('/home/stats')
